import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommonService } from 'src/app/trip-view/services/common.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { DataService } from 'src/app/data.service';
import { Subscription } from 'rxjs';
import { DateUtils } from 'src/app/utils/days-utils';
@Component({
  selector: 'app-bus-stop-card',
  templateUrl: './bus-stop-card.component.html',
  styleUrls: ['./bus-stop-card.component.scss'],
  animations: [
    trigger('expandedAnimation', [
      state('true', style({ transform: 'rotate(-180deg)' })),
      state('false', style({ transform: 'rotate(0deg)' })),
      transition('false <=> true', animate('1s ease-in-out'))
    ]),
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
        overflow: 'visible'
      })),
      transition('collapsed <=> expanded', [
        animate('500ms ease-in-out')
      ])
    ]),
    trigger('rotateArrow', [
      state('expanded', style({
        transform: 'rotate(180deg)'
      })),
      state('collapsed', style({
        transform: 'rotate(0deg)'
      })),
      transition('expanded => collapsed', [
        animate('0.3s')
      ]),
      transition('collapsed => expanded', [
        animate('0.3s')
      ])
    ])

  ]
})
export class BusStopCardComponent implements OnInit , OnDestroy {
  imgSrc: string;
  constructor(private commonService: CommonService, private envService: EnvironmentService , public dataService:DataService) { }
  expanded:boolean=false
  expandedCardIndex: number = -1;
  expandedStopComing:boolean=false;
  expandedStopCrossed:boolean=false;
  busStopsDetails:any;
  startStopIndex:any;
  currentStopIndex:any;
  upcomingStopIndex:any;
  lastStopIndex:any;
  expandedEmployeeCard: boolean = false;
  selectedCardIndex = -1;
  hideUpcomingCollapse=true;
  hideCrossedCollapse=true;
  stopsSkipped:number;
  firstStopSkipped=false;
  employeeInfo=false;
  employeeDetailsInfo;
  response;
  dataServiceObserver$:Subscription;
  actualEndTimeTrip;
  tripEndTime;
  ETS_MASTER_PROPERTIES : any = {}
  @Input() tripStatus='Started';

  ngOnInit(): void 
  {
    this.imgSrc = this.envService.getImgSrc();
    this.stopsSkipped=0
    this.response=this.commonService.response;
    this.actualEndTimeTrip = DateUtils.formatTimeWithZone(this.response['tripDetails'].actualEndTime, this.commonService.timeZone, 'HH:mm');
    this.tripEndTime = DateUtils.formatTimeWithZone(this.response['tripDetails'].actualEndTime, this.commonService.timeZone, 'HH:mm');
    

   
    this.commonService.busStopsDetails$.subscribe((data)=>
    {
      this.stopsSkipped= (data || []).filter(item => item?.skipped === true).length;
      if(data && Array.isArray(data) && data.length > 0 && data[0]?.skipped===true){
        this.firstStopSkipped=true;
      }
      console.log("bus data 1",data );
      
      this.busStopsDetails=data || [];
      
      this.busStopsDetails.forEach((stop) => {
        if (stop.actualArrivalTime == 0) {
          stop.actualColorClass = 'grey-text';
        } else {
          if (stop.actualArrivalTime <= stop.plannedArrivalTime) {
            stop.actualColorClass = 'green-text';
          } else {
            stop.actualColorClass = 'red-text';
          }
        }

        if (stop.arrivalTimeDiff > 0) {
          if (stop.arrivalTimeDiff >= 60) {
            const hours = Math.floor(stop.arrivalTimeDiff / 60);
            const minutes = stop.arrivalTimeDiff % 60;
            stop.arrivalTimeDiffFormatted = `${hours} hour ${minutes} mins`;
          } else {
            stop.arrivalTimeDiffFormatted = `${stop.arrivalTimeDiff} mins`;
          }
        }

      });
      console.log("data of bus stops",this.busStopsDetails);
      this.startStopIndex=0;
      this.lastStopIndex=data.length-1
      this.currentStopIndex =- 1;

      for (let i = data.length - 1; i >= 0; i--) {
        if (data[i].actualArrivalTime !== 0) {
          this.currentStopIndex = i;
          break;
        }
      }


    if(this.startStopIndex == this.currentStopIndex  )
      {
        this.currentStopIndex=this.startStopIndex
      }

      if (this.currentStopIndex < this.lastStopIndex )
      {
        this.upcomingStopIndex = this.currentStopIndex + 1;
      } 

      if((this.lastStopIndex - this.upcomingStopIndex) -1 <= 0 )
      {
        this.hideUpcomingCollapse=false
      }
      if((this.upcomingStopIndex-this.currentStopIndex)-1 <= 0)
      {
        this.hideCrossedCollapse=false
      }


    

      console.log("indexs ,start , current, upcoming,last",this.startStopIndex,this.currentStopIndex,this.upcomingStopIndex,this.lastStopIndex);
      
      
    })


    this.dataServiceObserver$ = this.dataService.ETS_PROPERTIES$.subscribe((properties:Record<string,any>) => {
      this.ETS_MASTER_PROPERTIES = properties;
    })
  }


  getEmployeeHiddenText(employee: any, type: string): string {
    const gender = employee.gender || '';
    const phone = employee?.phoneNumber || '';
    const isVendor = this.dataService.isVendorRole();
    const hidePhoneForVendors = this.ETS_MASTER_PROPERTIES?.HIDE_EMP_PHONE_NO_FROM_VENDORS;
    const hiddenInfoText = this.ETS_MASTER_PROPERTIES?.TEXT_SHOWN_FOR_HIDDEN_INFO_TO_VENDORS;

    const hidePhoneNumberForVendorsOrNot = () => {
        if (!isVendor) return false;
        
        switch (hidePhoneForVendors) {
            case 'All employees':
                return true;
            case 'Female employees only':
                return gender === 'Female';
            case 'Disabled':
                return false;
            default:
                return false;
        }
    };

    switch (type) {
        case 'phone':
            return hidePhoneNumberForVendorsOrNot() ? hiddenInfoText : phone;
      default:
            return '';
   }
  }

  ngOnDestroy(): void {
    this.dataServiceObserver$.unsubscribe();
  }
  toggleCard(index: number) {
    if (this.selectedCardIndex === index) {
      // if the same card is clicked again, collapse it
      this.selectedCardIndex = -1;
    } else {
      // if a different card is clicked, expand it and collapse the previously selected card
      this.selectedCardIndex = index;
    }
  }
  expandStopCrossed()
  {
    this.expandedStopCrossed=!this.expandedStopCrossed
  }
  expandStopComing()
  {
    this.expandedStopComing=!this.expandedStopComing
  }

  expandEmployeeCard(index:number)
  {
       if (this.expandedCardIndex === index) {
        this.expanded = false;
        this.expandedCardIndex = -1;
    } else {
        this.expanded = true;
        this.expandedCardIndex = index;
    }
  }

  openEmployeePopup(emp){
    this.employeeInfo=true;
    this.employeeDetailsInfo=emp;
    console.log('employeeInfo',emp);
    
  }
}
